module.exports = require('../_components/@alicd/next-input/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/input/index.js
// module id = 64
// module chunks = 0